module.exports = __webpack_public_path__ + "static/img/cDR3.7fccae29.png";